<template>
  <validation-observer
      ref="form"
      #default="{ invalid }"
      tag="form"
      class="repeater__form"
      style="overflow: visible"
  >
    <b-modal
        v-model="show"
        content-class="package-modal rounded-8"
        dialog-class="wameed-modal-md"
        no-fade
        :key="key"
    >
      <template slot="modal-header-close">
        <close-icon/>
      </template>
      <template slot="modal-title">
        <div class="d-block text-center">
          <h3 class="text-reg-18">
            {{ $t('orders.modal.payment_type.edit') }}
          </h3>
        </div>
      </template>


      <b-row>
        <b-col md="12">
          <wameed-dropdown
              v-model="form.payment_type"
              :label="$t('form.payment_type.label')"
              :placeholder="$t('form.payment_type.label')"
              variant="disable"
              :items="payment_types"
              class="wameed_dropdown"
              title="name"
              rules="required"
              @input="onChange"
              :no_options="$t('common.no_options')"
          />
        </b-col>

      </b-row>

      <template slot="modal-footer">
        <wameed-btn
            classes="  text-med-14 text-white mx-0 rounded-8"
            :title="$t('btn.update')"
            :disabled="invalid"
            type="submit"
            variant="main"
            @onClick="submit"
        />
        <wameed-btn
            classes="  text-med-14 text-font-secondary mx-0 rounded-8 "
            :title="$t('btn.cancel')"
            type="button"
            variant="gray"
            @onClick="closeModal()"
        />
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import {ValidationObserver} from 'vee-validate';
import {WameedBtn, WameedDropdown} from 'wameed-ui/dist/wameed-ui.esm';
import { PaymentType } from '@/enums/paymentType.enum';
import {mapGetters} from 'vuex';


export default {
  components: {
    ValidationObserver,
    WameedBtn,
    WameedDropdown,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    type: {
      type: String,
      default: '',
    },

    order: {
      // type: Object
    }
  },

  data() {
    return {
      key: 0,
      payment_types: PaymentType,
      form: {
        payment_type: '',
        order: null,
      },
      showSuccessModal: false,
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
  watch: {
    type(newVal) {
      if (newVal != null) {
        this.form.type = newVal;
      } else {
        this.form.type = '';
      }
    },
  },
  created() {
    if (this.type != null) {
      this.form.type = this.type;
    }
  },
  methods: {

    submit() {
      this.form.payment_type = this.form.payment_type.value;
      this.form.order = this.order;
      this.$store.dispatch('vendor/orders/updatePaymentType',
          {
            id: this.order.order_id,
            ...this.form
          }).then(() => {
        this.$emit('onComplete', true);
        this.closeModal();
        this.$store.commit('loadingFinish', null, {root: true});
      });

    },

    onChange() {
      this.key++;
    },


    closeModal() {
      this.show = false;
    },
  }
};
</script>
